export const PORTRAIT_PREVIEW_IMAGE_CLASS = 'new-design-workspace-preview-img--portrait';
export const PORTRAIT_PREVIEW_CONTAINER_CLASS = 'new-design-workspace-preview--portrait-image';

/** Images taller than this ratio expand the preview card vertically. */
export const PORTRAIT_PREVIEW_IMAGE_RATIO = 0.85;

/**
 * @param {HTMLImageElement} img
 */
export function applyPreviewImageLayoutClasses(img) {
  if (!img?.naturalWidth || !img?.naturalHeight) return;
  const ratio = img.naturalWidth / img.naturalHeight;
  const isPortrait = ratio < PORTRAIT_PREVIEW_IMAGE_RATIO;

  img.classList.toggle(PORTRAIT_PREVIEW_IMAGE_CLASS, isPortrait);

  const preview = img.closest('.new-design-workspace-preview');
  if (preview) {
    preview.classList.toggle(PORTRAIT_PREVIEW_CONTAINER_CLASS, isPortrait);
  }
}

/** @deprecated Use applyPreviewImageLayoutClasses */
export function applyWidePreviewImageClass(img) {
  applyPreviewImageLayoutClasses(img);
}
